export const config = {
  isDevelopment: process.env.NODE_ENV === 'development',
  backend: {
    api: process.env.REACT_APP_BACKEND_URL || '',
  },
  stripe: {
    pk: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  },
}
